import React from 'react'

export default function BottomBar() {
  const year = new Date().getFullYear()
  return (
    <footer className='flex justify-center lg:ml-0 my-6 py-2 lg:bg-gray-100 bottom-0 h-10 '>
      <p className='text-center text-gray-500 text-xs lg:text-base'>
        Copyright © {year}, All rights reserved by ScopeX.
      </p>
    </footer>
  )
}
